module.exports = __webpack_public_path__ + "static/img/coner2.e422d0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/coner2.png
// module id = PlWh
// module chunks = 1